import React from "react";
import PropTypes from "prop-types";

export function SmartList({
    items,
    solitaryItemClassName = "",
    listClassName = "",
    itemClassName = "",
}) {
    if (!items.length) {
        return <></>;
    }
    return items.length === 1 ? (
        <div className={solitaryItemClassName}>{items[0].display}</div>
    ) : (
        <ul className={listClassName}>
            {items.map(({ key, display }) => (
                <li key={key} className={itemClassName}>
                    {display}
                </li>
            ))}
        </ul>
    );
}

SmartList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            display: PropTypes.node,
        })
    ).isRequired,
    solitaryItemClassName: PropTypes.string,
    listClassName: PropTypes.string,
    itemClassName: PropTypes.string,
};

SmartList.defaultProps = {
    solitaryItemClassName: "",
    listClassName: "",
    itemClassName: "",
};

export function InlineList({ className, items }) {
    return (
        <div className={`inline-list ${className}`}>
            <SmartList
                solitaryItemClassName="inline-list__single-item"
                listClassName="inline-list__list"
                itemClassName="inline-list__item"
                items={items}
            />
            <style jsx>{`
                .inline-list :global(.inline-list__single-item) {
                    display: inline-block;
                }
                .inline-list :global(.inline-list__list) {
                    margin: -0.5em 0 0 -1em;
                    padding: 0;
                    list-style-type: none;
                }
                .inline-list :global(.inline-list__item) {
                    display: inline-block;
                    margin-top: 0.5em;
                    margin-left: 1em;
                }
            `}</style>
            <style jsx>{`
                .inline-list :global(.inline-list__list) {
                    display: flex;
                    flex-wrap: wrap;
                }
            `}</style>
        </div>
    );
}

InlineList.propTypes = {
    className: PropTypes.string,
    items: SmartList.propTypes.items,
};

InlineList.defaultProps = {
    className: "",
};
